<template>
  <v-card class="mx-auto top20" max-width="auto">
    <v-card-text>
      <p :class="rowClass" class="product-title text--primary">
        <b>{{ good.article }}</b> {{ good.name }}
      </p>
      <p :class="rowClass">
        Стоимость: <b>{{ price }} <span class="currency-rub"></span></b>
      </p>

      <v-card-actions>
        <div class="center">
          <v-btn
            class="mx-2"
            fab
            small
            color="error"
            @click="onDelete"
            :disabled="disableQuantityMinusButton"
          >
            <v-icon dark> mdi-minus </v-icon>
          </v-btn>

          <span class="text-h5 pl-3 pr-3">{{ quantity }}</span>

          <v-btn
            class="mx-2"
            fab
            small
            color="success"
            @click="onRestore"
            :disabled="disableQuantityPlusButton"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RawProductListRow",
  props: ["good", "paymentIsAvailable", "updSum", "deletionProhibited"],
  computed: {
    rowClass() {
      return {
        "text-decoration-line-through":
          this.good.deleted == this.good.initial_amount,
      };
    },
    quantity() {
      return this.good.quantity;
    },
    price() {
      return this.good.price;
    },
    disableQuantityMinusButton() {
      return (
        this.quantity == 0 ||
        this.updSum - this.good.one_item_price * this.good.packing_ration < 0 ||
        this.deletionProhibited ||
        !this.paymentIsAvailable
      );
    },
    disableQuantityPlusButton() {
      return (
        this.quantity == this.good.initial_amount || this.deletionProhibited
      );
    },
  },
  methods: {
    onDelete() {
      this.$store.commit("rawDeleteGood", this.good.id);
      let sum =
        parseFloat(this.$store.getters.updSum) -
        this.good.one_item_price * this.good.packing_ration;
      sum = parseFloat(sum).toFixed(2);
      this.$store.commit("rawUpdateSum", sum);
    },
    onRestore() {
      this.$store.commit("rawRestoreGood", this.good.id);
      let sum =
        parseFloat(this.$store.getters.updSum) +
        this.good.one_item_price * this.good.packing_ration;
      sum = parseFloat(sum).toFixed(2);
      this.$store.commit("rawUpdateSum", sum);
    },
  },
};
</script>
